import { createFileRoute, redirect } from "@tanstack/react-router";
import { operatorWorkspaceLocation } from "../components/operator/operatorWorkspaceNavigation.route";
export const Route = createFileRoute("/_workspace/chat")({
  beforeLoad: ({ search }) => {
    throw redirect({
      ...operatorWorkspaceLocation({ ...search, view: "overview" }),
      replace: true,
    });
  },
});
